import React, { useContext } from 'react';

import { app, media } from 'context';
import { Layout, PillButton, Text } from 'ds';
import { OFFICE_REQUEST_PATH } from 'routes';

interface Props {}

const FourTimesBetter: React.FC<Props> = () => {
  const { xs } = useContext(media);
  const { contentPaddingX } = useContext(app);
  return (
    <Layout
      position="relative"
      paddingY={xs ? 64 : 128}
      paddingX={contentPaddingX}
      direction="column"
      gap={32}
      align="center"
    >
      <Text size={xs ? 'headline-lg' : 'display-sm'} color="purple-gradient" align="center">
        4x faster, 4x more affordable
      </Text>
      <Text size="body-md" color="gray-400" align="center">
        Office tasks, automated — so you can focus on what matters.
      </Text>
      <Layout width={200}>
        <PillButton size="lg" type="purpleGradient" href={OFFICE_REQUEST_PATH} text="Get started" fullWidth />
      </Layout>
    </Layout>
  );
};

export default FourTimesBetter;
